import { CognitoUserPool} from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-east-2_XhG6HzxHf",
    ClientId: "7j8sko588n3j0p5n07npnonfd8"
}

export default new CognitoUserPool(poolData);